import { defineReactiveModel, Persistable } from "vue-app-utils";
import Model from "@/models/model";

const PaymentMethod = {
  extends: Model,
  mixins: [
    Persistable
  ]
};

export default defineReactiveModel(PaymentMethod);
